/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WebProvisionCredentialRedeemConfirmationRequest } from '../../models/web-provision-credential-redeem-confirmation-request';
import { WebProvisionCredentialRedeemConfirmationResponse } from '../../models/web-provision-credential-redeem-confirmation-response';

export interface ConfirmCredentialRedemption$Params {
  id: string;
      body: WebProvisionCredentialRedeemConfirmationRequest
}

export function confirmCredentialRedemption(http: HttpClient, rootUrl: string, params: ConfirmCredentialRedemption$Params, context?: HttpContext): Observable<StrictHttpResponse<WebProvisionCredentialRedeemConfirmationResponse>> {
  const rb = new RequestBuilder(rootUrl, confirmCredentialRedemption.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WebProvisionCredentialRedeemConfirmationResponse>;
    })
  );
}

confirmCredentialRedemption.PATH = '/webprovision/{id}/confirm';
